import { analyticsApiRef, useApi } from '@backstage/core-plugin-api';
import type { AnalyticsContextValue } from '@backstage/core-plugin-api';

export const useTrackEvent = () => {
  const analytics = useApi(analyticsApiRef);

  return (
    action: string,
    subject: string,
    attributes: Record<string, any> = {},
    context: AnalyticsContextValue,
  ) => {
    analytics.captureEvent({
      action,
      subject,
      context,
      attributes,
    });
  };
};
